import styled, { css } from "styled-components";
export var ScrollWrapper = styled.div.withConfig({
    componentId: "sc-ea65b140-0"
})([
    "-webkit-overflow-scrolling:touch;",
    ";",
    ";",
    ";",
    ";",
    ";"
], function(props) {
    return !props.$hideScrollBar ? "" : css([
        "scrollbar-width:none;&::-webkit-scrollbar{-webkit-appearance:none;height:0;}&::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,0);}"
    ]);
}, function(props) {
    return props.$horizontal ? css([
        "overflow-y:hidden;overflow-x:auto;"
    ]) : css([
        "overflow-x:hidden;overflow-y:auto;"
    ]);
}, function(props) {
    var value = typeof props.$maxWidth === "number" ? css([
        "",
        "px"
    ], props.$maxWidth) : props.$maxWidth;
    return !props.$maxWidth ? "" : css([
        "width:",
        ";max-width:",
        ";"
    ], value, value);
}, function(param) {
    var minHeight = param.$minHeight;
    var value = typeof minHeight === "number" ? css([
        "",
        "px"
    ], minHeight) : minHeight;
    return minHeight ? css([
        "min-height:",
        ";"
    ], value) : "";
}, function(props) {
    var value = typeof props.$maxHeight === "number" ? css([
        "",
        "px"
    ], props.$maxHeight) : props.$maxHeight;
    return !props.$maxHeight ? "" : css([
        "height:",
        " max-height:",
        ""
    ], value, value);
});
